import { API_ACTION_TYPES, ACTION_TYPES, createAction } from "@Utils";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useIpGeolocDetailsStore } from "repoV2/features/Common/modules/UserIp/UserIp.store";

export const useFetchNavbarItemData = (hostName: string) => {
    const dispatch = useDispatch();

    const ipGeolocDetailsUpdatedAt = useIpGeolocDetailsStore(
        state => state?.ipGeolocDetails?.metadata?.updatedAt
    );

    useEffect(() => {
        // since this api response contains plan prices, so we should only call this once ip geolocation is resolved
        if (ipGeolocDetailsUpdatedAt) {
            dispatch(
                createAction(ACTION_TYPES.UTILS.API_CALL, {
                    apiActionType: API_ACTION_TYPES.FETCH_HOST_PLANS,
                    urlArgs: {
                        hostName,
                    },
                })
            );
        }
    }, [ipGeolocDetailsUpdatedAt]);

    useEffect(() => {
        dispatch(
            createAction(ACTION_TYPES.UTILS.API_CALL, {
                apiActionType: API_ACTION_TYPES.FETCH_TEAM_DETAILS,
                urlArgs: {
                    hostName,
                },
            })
        );
    }, []);

    useEffect(() => {
        dispatch(
            createAction(ACTION_TYPES.UTILS.API_CALL, {
                apiActionType: API_ACTION_TYPES.FETCH_BLOG_POSTS,
                urlArgs: { page: 1, hostName },
            })
        );
    }, []);
};
